import React, { useState } from 'react';
import axios from '../config/axios';
import { getAuthHeaders } from '../utils/auth';

const ChoreCard = ({ chore, kidUserId, onSubmit, formatCurrency }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notes, setNotes] = useState('');
    const [showSubmitForm, setShowSubmitForm] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await axios.post('/api/v1/submissions', {
                challenge_id: chore.id,
                kid_user_id: kidUserId,
                notes: notes || 'Completed!'
            }, {
                headers: getAuthHeaders()
            });
            setShowSubmitForm(false);
            setNotes('');
            if (onSubmit) onSubmit();
        } catch (err) {
            console.error('Failed to submit chore:', err);
            alert('Failed to submit chore. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="chore-card" role="article" aria-label={`Chore: ${chore.title}, reward ${formatCurrency(chore.reward_amount)}`}>
            <div className="chore-header">
                <h3>{chore.title}</h3>
                <span className="chore-reward">{formatCurrency(chore.reward_amount)}</span>
            </div>
            {chore.description && (
                <p className="chore-description">{chore.description}</p>
            )}
            {chore.recurrence && (
                <p className="chore-recurrence">Repeats: {chore.recurrence}</p>
            )}

            {!showSubmitForm ? (
                <button
                    className="btn-primary btn-submit-chore"
                    onClick={() => setShowSubmitForm(true)}
                >
                    Submit Completion
                </button>
            ) : (
                <div className="submit-form">
                    {chore.requires_evidence && (
                        <div style={{ marginBottom: '10px' }}>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>
                                📸 Photo Proof Required
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                aria-label="Upload photo evidence"
                                onChange={async (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const formData = new FormData();
                                        formData.append('file', file);
                                        formData.append('folder', 'evidence');
                                        try {
                                            const res = await axios.post('/api/v1/upload', formData, {
                                                headers: { 'Content-Type': 'multipart/form-data', ...getAuthHeaders() }
                                            });
                                            setNotes(prev => prev + (prev ? '\n' : '') + `Evidence: ${res.data.url}`);
                                        } catch (err) {
                                            alert('Upload failed');
                                            console.error(err);
                                        }
                                    }
                                }}
                            />
                        </div>
                    )}
                    <textarea
                        placeholder="Add a note (optional)"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="2"
                        aria-label="Completion notes"
                    />
                    <div className="submit-actions">
                        <button
                            className="btn-primary"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                        <button
                            className="btn-secondary"
                            onClick={() => setShowSubmitForm(false)}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChoreCard;
